<template>
<div class="chapter">
<div class="inner_page">
<h2 class="h2"><a id="page_vii"></a><a id="ch005_toc"></a><strong>Contents</strong></h2>
<p class="toc"><a class="nounder" href="#/xhtml/ch006_ack#ch006_ack"><em>Acknowledgments</em></a></p>
<p class="toc"><a class="nounder" href="#/xhtml/ch007_Abb#ch007_Abb"><em>Abbreviations List</em></a></p>
<p class="tocg"><a class="nounder" href="#/xhtml/ch008_intro#ch008_intro">Introduction</a></p>
<p class="toc1"><a class="nounder" href="#/xhtml/ch009_ch01#ch009_ch01">1   The Long Arm of the State</a></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch010_ch02#ch010_ch02" title="Link target outside of Sample">2   Prelude to War</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch011_ch03#ch011_ch03" title="Link target outside of Sample">3   “Reservoirs of Infection”: Science, Medicine, and Contagious Bodies</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch012_ch04#ch012_ch04" title="Link target outside of Sample">4   “A Buffer of Whores”: Military and Social Ambivalence about Sexuality and Gender</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch013_ch05#ch013_ch05" title="Link target outside of Sample">5   “Spell ‘IT’ to the Marines”: The Contradictory Messages of Popular Culture</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch014_ch06#ch014_ch06" title="Link target outside of Sample">6   Behind the Lines: The War against Women</span></p>
<p class="toc1"><span class="nounder" href="#/xhtml/ch015_conclu#ch015_conclu" title="Link target outside of Sample">7   Conclusion</span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch016_app01#ch016_app01" title="Link target outside of Sample"><em>Appendix 1: The Eight Point Agreement</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch017_app02#ch017_app02" title="Link target outside of Sample"><em>Appendix 2: The May Act</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch018_app03#ch018_app03" title="Link target outside of Sample"><em>Appendix 3: Federal Agencies: The Social Protection Division</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch019_notes#ch019_notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch020_biblo#ch020_biblo" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch021_index#ch021_index" title="Link target outside of Sample"><em>Index</em></span></p>
<p class="toc"><span class="nounder" href="#/xhtml/ch022_about_the_author#ch022_about_the_author" title="Link target outside of Sample"><em>About the Author</em></span><a id="page_viii"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch005_toc.vue?e7558728